module.exports = __webpack_public_path__ + "static/media/LIMONES.3afda455.webp";